(() => {
  if (window.FigmaPromoProductCardsLoaded) {
    return;
  }

  window.FigmaPromoProductCardsLoaded = true;

  const rootSelector = '[data-figma-promo-products]';

  function initPromoProducts(root) {
    if (!root || root.dataset.figmaPromoProductsInitialized === 'true') {
      return;
    }

    root.dataset.figmaPromoProductsInitialized = 'true';

    const cards = Array.from(root.querySelectorAll('[data-promo-card]'));
    const panels = Array.from(root.querySelectorAll('[data-promo-panel]'));
    const carousels = Array.from(root.querySelectorAll('[data-promo-carousel]'));
    const autoplayEnabled = root.dataset.promoAutoplay === 'true';
    const autoplayDelay = 4000;
    let autoplayTimer = null;

    function getActiveCarousel() {
      return carousels.find((carousel) => carousel.dataset.productId === root.dataset.activeProduct);
    }

    function hasMultipleSlides(carousel) {
      return carousel && carousel.querySelectorAll('[data-promo-slide]').length > 1;
    }

    function setActiveSlide(carousel, slideIndex) {
      if (!carousel) {
        return;
      }

      const slides = Array.from(carousel.querySelectorAll('[data-promo-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-promo-slide-dot]'));

      if (!slides.length) {
        return;
      }

      const normalizedIndex = ((slideIndex % slides.length) + slides.length) % slides.length;
      carousel.dataset.activeSlide = String(normalizedIndex);

      slides.forEach((slide) => {
        slide.dataset.active = String(Number(slide.dataset.slideIndex) === normalizedIndex);
      });

      dots.forEach((dot) => {
        const isActive = Number(dot.dataset.slideIndex) === normalizedIndex;
        dot.dataset.active = String(isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    function stopAutoplay() {
      if (!autoplayTimer) {
        return;
      }

      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (!autoplayEnabled) {
        return;
      }

      stopAutoplay();

      autoplayTimer = window.setInterval(() => {
        if (document.hidden) {
          return;
        }

        const activeCarousel = getActiveCarousel();
        if (!hasMultipleSlides(activeCarousel)) {
          return;
        }

        setActiveSlide(activeCarousel, Number(activeCarousel.dataset.activeSlide || 0) + 1);
      }, autoplayDelay);
    }

    function restartAutoplay() {
      if (!autoplayEnabled) {
        return;
      }

      startAutoplay();
    }

    function setActiveProduct(productId, resetCarousel = true) {
      if (!productId) {
        return;
      }

      root.dataset.activeProduct = productId;

      cards.forEach((card) => {
        const isActive = card.dataset.productId === productId;
        card.dataset.active = String(isActive);
        card.setAttribute('aria-selected', String(isActive));
      });

      panels.forEach((panel) => {
        panel.dataset.active = String(panel.dataset.productId === productId);
      });

      const activeCarousel = carousels.find((carousel) => carousel.dataset.productId === productId);
      if (activeCarousel && resetCarousel) {
        setActiveSlide(activeCarousel, 0);
      }
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        if (card.disabled || card.dataset.soldOut === 'true') {
          return;
        }

        setActiveProduct(card.dataset.productId);
        restartAutoplay();
      });
    });

    carousels.forEach((carousel) => {
      setActiveSlide(carousel, Number(carousel.dataset.activeSlide || 0));

      carousel.addEventListener('click', (event) => {
        const previousButton = event.target.closest('[data-promo-slide-prev]');
        const nextButton = event.target.closest('[data-promo-slide-next]');
        const dot = event.target.closest('[data-promo-slide-dot]');

        if (previousButton) {
          setActiveSlide(carousel, Number(carousel.dataset.activeSlide || 0) - 1);
          restartAutoplay();
          return;
        }

        if (nextButton) {
          setActiveSlide(carousel, Number(carousel.dataset.activeSlide || 0) + 1);
          restartAutoplay();
          return;
        }

        if (dot) {
          setActiveSlide(carousel, Number(dot.dataset.slideIndex || 0));
          restartAutoplay();
        }
      });
    });

    const initialCard = cards.find((card) => card.getAttribute('aria-selected') === 'true') || cards[0];
    if (initialCard) {
      setActiveProduct(initialCard.dataset.productId, false);
    }

    startAutoplay();

    root.figmaPromoProductCardsCleanup = stopAutoplay;

    root.addEventListener('shopify:block:select', (event) => {
      const selectedCard = event.target.closest?.('[data-promo-card]');
      if (selectedCard) {
        setActiveProduct(selectedCard.dataset.productId);
        restartAutoplay();
      }
    });
  }

  function initAllPromoProducts(container = document) {
    const roots = container.matches?.(rootSelector)
      ? [container]
      : Array.from(container.querySelectorAll(rootSelector));

    roots.forEach(initPromoProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllPromoProducts());
  } else {
    initAllPromoProducts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllPromoProducts(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.(rootSelector)
      ? [event.target]
      : Array.from(event.target.querySelectorAll(rootSelector));

    roots.forEach((root) => {
      root.figmaPromoProductCardsCleanup?.();
    });
  });
})();
